import { Button, createStyles, Theme, WithStyles, withStyles } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import SaveIcon from '@material-ui/icons/Save'
import * as R from 'ramda'
import React, { useEffect, useState } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import {genericAction} from '../../../features/pacticipantOutcomeSlice'

const mapStateToProps = (state:any) => ({
  // measurableSkillGain: state.participantOutcome.measurableSkillGain,
  // dateSkillAttained: state.participantOutcome.dateSkillAttained,
  credentialDoc1: state.participantOutcome.credentialDoc1,
  credentialDoc2: state.participantOutcome.credentialDoc2,
  credentialType:state.participantOutcome.credentialType,
  credentialType2:state.participantOutcome.credentialType2,
  dateCredentialAttained1:state.participantOutcome.dateCredentialAttained1,
  dateCredentialAttained2:state.participantOutcome.dateCredentialAttained2,
  credential1: state.participantOutcome.credential1,
  credential2: state.participantOutcome.credential2,
  existing_credentialDoc1: state.participantOutcome.existing_credentialDoc1,
  existing_credentialDoc2: state.participantOutcome.existing_credentialDoc2,
  existing_credentialType:state.participantOutcome.existing_credentialType,
  existing_credentialType2:state.participantOutcome.existing_credentialType2,
  existing_dateCredentialAttained1:state.participantOutcome.existing_dateCredentialAttained1,
  existing_dateCredentialAttained2:state.participantOutcome.existing_dateCredentialAttained2,
  existing_credential1: state.participantOutcome.existing_credential1,
  existing_credential2: state.participantOutcome.existing_credential2,
  incumbentEmployer: state.participantOutcome.incumbentEmployer,
  existing_incumbentEmployer: state.participantOutcome.existing_incumbentEmployer,
  jobPlacementEmployer: state.participantOutcome.jobPlacementEmployer,
  existing_jobPlacementEmployer: state.participantOutcome.existing_jobPlacementEmployer,
  internshipEmployer: state.participantOutcome.internshipEmployer,
  existing_internshipEmployer: state.participantOutcome.existing_internshipEmployer,
})

const mapDispatchToProps = { genericAction };

const connector = connect(
  mapStateToProps,
  mapDispatchToProps
)

type PropsFromRedux = ConnectedProps<typeof connector>

interface GEORProps extends WithStyles<typeof styles>, PropsFromRedux {
	onCancel: () => void
	isSubmitDisabled: boolean
}

export type RouterProps = GEORProps & RouteComponentProps & WithStyles
// let initState: any = null
export const OutcomesFormActions: React.FC<GEORProps & RouterProps> = (props: RouterProps) => {
	const { 
    classes, 
    history, 
    onCancel, 
    isSubmitDisabled,
    // measurableSkillGain,
    // dateSkillAttained,
    credentialDoc1, 
    credentialDoc2,
    credentialType,
    credentialType2,
    dateCredentialAttained1,
    dateCredentialAttained2,
    credential1,
    credential2,
    existing_credentialDoc1,
    existing_credentialDoc2,
    existing_credentialType,
    existing_credentialType2,
    existing_dateCredentialAttained1,
    existing_dateCredentialAttained2,
    existing_credential1,
    existing_credential2,
    incumbentEmployer,
    existing_incumbentEmployer,
    jobPlacementEmployer,
    existing_jobPlacementEmployer,
    internshipEmployer,
    existing_internshipEmployer,
   } = props
	const [disabled, setDisabled] = useState(isSubmitDisabled)
  const [initState,setInitState] = useState<any>()

  const handleCancelClick = ()=>{
    props.genericAction({
      existing_credentialDoc1:null,
      existing_credentialDoc2: null,
      existing_credentialType: credentialType,
      existing_credentialType2: credentialType2,
      existing_dateCredentialAttained1: dateCredentialAttained1,
      existing_dateCredentialAttained2: dateCredentialAttained2,
      existing_credential1: credential1,
      existing_credential2: credential2,
      existing_incumbentEmployer: incumbentEmployer,
      existing_jobPlacementEmployer: jobPlacementEmployer,
      existing_internshipEmployer: internshipEmployer,
    })
    props.onCancel()
  }
  

	useEffect(() => {
    const currentState = {
      // measurableSkillGain,
      // dateSkillAttained,
      credentialDoc1, 
      credentialDoc2,
      credentialType,
      credentialType2,
      dateCredentialAttained1,
      dateCredentialAttained2,
      credential1,
      credential2,
      internshipEmployer,
      jobPlacementEmployer,
      incumbentEmployer
    }
    // if(initState){
      const old_state:any = {
        credentialDoc1:null,
        credentialDoc2:null ,
        credentialType:existing_credentialType,
        credentialType2:existing_credentialType2,
        dateCredentialAttained1:existing_dateCredentialAttained1,
        dateCredentialAttained2:existing_dateCredentialAttained2,
        credential1:existing_credential1,
        credential2:existing_credential2,
        internshipEmployer:existing_internshipEmployer,
        jobPlacementEmployer:existing_jobPlacementEmployer,
        incumbentEmployer:existing_incumbentEmployer
      }
      debugger
      console.log(`old_state`,old_state)
      console.log(`currentState`,currentState)

      const isSame = R.equals(old_state,currentState)
      console.log(`isSame=${isSame} isSubmitDisabled=${isSubmitDisabled}`)
      setDisabled(isSubmitDisabled && isSame)
    // }
		// else{
    //   setDisabled(isSubmitDisabled)
    // }
	}, [isSubmitDisabled,
    // measurableSkillGain,
      // dateSkillAttained,
    credentialDoc1, 
    credentialDoc2,
    credentialType,
    credentialType2,
    dateCredentialAttained1,
    dateCredentialAttained2,
    credential1,
    credential2,
    incumbentEmployer,
    jobPlacementEmployer,
    internshipEmployer
    ]
    )

  useEffect(()=>{
    if(!initState){
      setInitState({
        // measurableSkillGain,
        // dateSkillAttained,
        credentialDoc1, 
        credentialDoc2,
        credentialType,
        credentialType2,
        dateCredentialAttained1,
        dateCredentialAttained2,
        credential1,
        credential2
      })
      // initState = {
      //   // measurableSkillGain,
      //   // dateSkillAttained,
      //   credentialDoc1, 
      //   credentialDoc2,
      //   credentialType,
      //   credentialType2,
      //   dateCredentialAttained1,
      //   dateCredentialAttained2,
      //   credential1,
      //   credential2
      // }
    }
  },[
    // measurableSkillGain,
    // dateSkillAttained,
    credentialDoc1, 
    credentialDoc2,
    credentialType,
    credentialType2,
    dateCredentialAttained1,
    dateCredentialAttained2,
    credential1,
    credential2])

	return (
		<div className={classes.formActions}>
			<Button
				variant="contained"
				size="medium"
				color="primary"
				className={classes.button}
				type="submit"
				disabled={disabled}
			>
				<SaveIcon className={classes.icon} />
				Save
			</Button>

			{disabled ? (
				<Button
					variant="contained"
					size="medium"
					color="default"
					className={classes.button}
					onClick={history.goBack}
					data-auto="back-btn"
				>
					<ArrowBackIcon className={classes.icon} />
					Go Back
				</Button>
			) : (
				<Button
					variant="contained"
					size="medium"
					color="default"
					className={classes.button}
					onClick={handleCancelClick}
					data-auto="cancel-form-edit-btn"
				>
					Cancel
				</Button>
			)}
		</div>
	)
}

const styles = (theme: Theme) =>
	createStyles({
		formActions: {
			display: 'flex',
			flex: 1,
			justifyContent: 'flex-end',
			padding: `${theme.spacing.unit * 2}px 0`,
		},
		button: {
			marginLeft: `${theme.spacing.unit * 2}px`,
		},
		icon: {},
		sectionSubtitle: {
			padding: `${theme.spacing.unit}px 0`,
		},
	})

// TODO - check why router props are not being recognized
// @ts-ignore
export default connector(withRouter(withStyles(styles)(OutcomesFormActions)))
